import { MessageChatCircle } from "@untitled-ui/icons-react";
import { type TFunction } from "i18next";

import MessengerWrapper from "./user/components/MessengerWrapper";

export default {
  name: "messenger",
  priority: 9,
  icon: MessageChatCircle,
  wrapper: {
    user: MessengerWrapper,
  },
  menu: ({ t }: { t: TFunction }) => ({
    admin: [
      {
        label: t("Messenger", { ns: "messenger.shared" }),
        icon: <MessageChatCircle />,
        to: "/admin/messenger/groups",
        permission: "messenger.messenger-group.view",
      },
    ],
  }),
} satisfies ModuleData;
